import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, GridDataSource } from '../../../../shared/session/index';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { PageEvent } from '@angular/material';
import { UserService } from '../../user/shared/user.service';

@Component({
  selector: 'app-rol-user-list',
  templateUrl: 'rol-user-list.component.html',
})

export class UserRolListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;

  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  pageSize: number;
  pageEvent: PageEvent;

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.pageSize = 0;
    this.pageEvent = new PageEvent();
    this.msgErrorGet = 'Error al listar los Usuarios';
    this.displayedColumns = ['UserID', 'entidadName', 'AplicacionName', 'RoleName', 'Name', 'Descripcion', 'Status'];
  }

  searchEmit(data: any) {
    this.buscarUsers(this.data.rol.ID, data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  buscarUsers(RoleID: number, filtro: string) {
    this.listRolUser(RoleID, filtro);
  }

  listRolUser(RoleID: number, filtro: string) {
    this.loaderService.show();
    this.userService.listarPorRole(RoleID, filtro)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}